import type { FC } from 'react';
import { ShareOutline } from '@eqi-investimentos/icons/web';
import {
  Button,
  type ButtonProps,
  useToast,
  Text,
} from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { copyTextToClipboard } from '@/utils/clipboard';
import { toastConfigDefault } from '@/utils/toast';

export const ShareButton: FC<ShareButtonProps> = ({ href, buttonProps }) => {
  const toast = useToast(toastConfigDefault.primary);
  const t = useT();

  return (
    <Button
      aria-label={t('attributes.share')}
      rightIcon={<ShareOutline />}
      gap="2xs"
      variant="naked"
      color="content.brand"
      onClick={() => {
        copyTextToClipboard(href);
        toast({
          description: 'Link copiado com sucesso!',
          status: 'warning',
        });
      }}
      {...buttonProps}
    >
      <Text size="label.xl" fontWeight="semibold">
        {t('attributes.share')}
      </Text>
    </Button>
  );
};

export type ShareButtonProps = {
  href: string;
  buttonProps?: Omit<ButtonProps, 'aria-label'>;
};
